import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject, fromEvent, merge, of} from 'rxjs';
import {mapTo, startWith} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  public isOnline$ = new BehaviorSubject<boolean>(navigator.onLine);
  constructor(private zone: NgZone) {

    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));

    merge(online$, offline$)
      .pipe(startWith(navigator.onLine))
      .subscribe((status) => {
        this.zone.run(() => this.isOnline$.next(status));
      });
  }
}
